/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext } from "react";
import AppContext from "../../../../Store/AppContext";
import {
  Listar as ListarTemplateEmail,
  Detalhes as DetalhesTemplateEmail,
  Remover as RemoverTemplateEmail,
  Incluir as IncluirTemplateEmail,
  Atualizar as AtualizarTemplateEmail,
} from "../../../../Services/TemplateEmail";

import { useHistory } from "react-router-dom";
import { Listar as ListarProduto } from "../../../../Services/Produto";
import { validarPermissoesPagina } from "../../../../Utils/validarPermissoesPagina";
export const TemplateEmailContext = createContext();

const tituloTela = "Template Email";

const defaultData = {
  templateEmailId: 0,
  produtoId: 0,
  templateEmailNome: "",
  templateEmailAssunto: "",
  templateEmailMsg: "",
  templateEmailTipo: "I",
};

const searchData = {
  produtoId: 0,
  templateEmailNome: "",
};

const columnsDefinition = [
  {
    text: "Id",
    dataField: "templateEmailId",
    hidden: true,
  },
  {
    text: "Nome do Template",
    dataField: "templateEmailNome",
    headerStyle: { width: "400px" },
    sort: true,
  },
  {
    text: "Produto",
    dataField: "produtoNome",
    headerStyle: { width: "300px" },
    sort: true,
  },
  {
    text: "Tipo",
    dataField: "templateEmailTipo",
    headerStyle: { width: "100px" },
    sort: true,
  },
];

function initialState() {
  return {
    searchData: searchData,
    resultSearch: [],
    columnsDefinition: columnsDefinition,
    data: defaultData,
    formDisabled: true,
    produtos: [],
    chavesTemplate: [],
  };
}

const TemplateEmailProvider = ({ children }) => {
  const { showLoading, hideLoading, showMessage, setTituloTela } = useContext(
    AppContext
  );
  const [values, setValues] = useState(initialState());
  let history = useHistory();

  async function loadDependences() {
    const permissoesPagina = validarPermissoesPagina();
    const responseListarProduto = await ListarProduto({});

    if (
      !responseListarProduto.success
    ) {
      showMessage("Erro", "Erro Inesperado ao carregar dados basicos.");
      return {
        permissoesPagina: [],
        produtos: [],
      };
    }

    const produtos = await responseListarProduto.produtos.filter((item) => item.produtoAtivo === 'A');

    return { permissoesPagina, produtos };
  }

  const resetScreen = () => {
    showLoading();
    async function carregarDependencias() {
      const dependencias = await loadDependences();
      setTituloTela(tituloTela);
      setValues({
        ...initialState(),
        permissoesPagina: await dependencias.permissoesPagina,
        produtos: await dependencias.produtos
      });
      hideLoading();
    }
    carregarDependencias();
  };

  const searchHandler = async () => {
    showLoading();
    const responseListar = await ListarTemplateEmail(values.searchData);
    if (!responseListar.success) {
      showMessage("Erro", "Erro Inesperado durante a pesquisa.");
      hideLoading();
      return;
    }

    const resultSearchData = await responseListar.templatesEmail;

    resultSearchData.map((data) => (data.Id = data.templateEmailId));

    setValues({
      ...values,
      resultSearch: resultSearchData,
    });

    if (resultSearchData.length === 0) {
      showMessage("Alerta", "Nenhum registro encontrado.");
    }
    hideLoading();
  };

  const removeHandler = async (id) => {
    showLoading();

    const responseRemover = await RemoverTemplateEmail(id);

    if (!responseRemover.success) {
      hideLoading();
      showMessage(
        "Erro",
        `Erro durante a exclusão: ${responseRemover.message}`
      );
      return;
    }
    searchHandler();
    hideLoading();
    showMessage("Sucesso", "Registro excluido.");
  };

  const getDetailHandler = async (id) => {
    showLoading();
    const dependencias = await loadDependences();

    if (id > 0) {
      const responseDetalhes = await DetalhesTemplateEmail(id);

      const { success, templateEmail } = await responseDetalhes;

      if (!success) {
        showMessage("Erro", "Erro ao buscar os detalhes do registro.");
        setValues({
          ...values,
          data: defaultData,
          permissoesPagina: await dependencias.permissoesPagina,
        });
      }

      setValues({
        ...values,
        data: templateEmail,
        permissoesPagina: await dependencias.permissoesPagina,
        produtos: await dependencias.produtos
      });
    } else {
      setValues({
        ...values,
        data: {
          ...defaultData,
          templateEmailId: 0,
        },
        permissoesPagina: await dependencias.permissoesPagina,
        produtos: await dependencias.produtos,
        formDisabled: false,
      });
    }
    hideLoading();
  };

  const createData = async () => {
    showLoading();
    const responseIncluir = await IncluirTemplateEmail(values.data);
    if (!responseIncluir.success) {
      hideLoading();
      showMessage(
        "Erro",
        `Erro ao criar o registro: ${responseIncluir.message}`
      );
      responseIncluir.errors.map((erro) =>
        showMessage("Erro", erro.errorMessage)
      );
      return;
    }

    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro criado.");
    history.goBack();
  };

  const editHandler = () => {
    setValues({
      ...values,
      formDisabled: false,
    });
  };

  const updateData = async () => {
    showLoading();
    const responseAtualizar = await AtualizarTemplateEmail(values.data);
    if (!responseAtualizar.success) {
      hideLoading();
      showMessage(
        "Erro",
        `Erro ao atualizar o registro: ${responseAtualizar.message}`
      );
      responseAtualizar.errors.map((erro) =>
        showMessage("Erro", erro.errorMessage)
      );
      return;
    }
    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro atualizado.");
    history.goBack();
  };

  const saveHandler = async () => {
    if (values.data.templateEmailId === 0) {
      await createData();
    } else {
      await updateData();
    }
  };

  const cancelHandler = () => {
    setValues({
      ...values,
      data: defaultData,
      formDisabled: true,
    });
  };

  return (
    <TemplateEmailContext.Provider
      value={{
        values,
        setValues,
        resetScreen,
        searchHandler,
        cancelHandler,
        removeHandler,
        saveHandler,
        getDetailHandler,
        editHandler
      }}
    >
      {children}
    </TemplateEmailContext.Provider>
  );
};

export default TemplateEmailProvider;
